exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-64faa90b] .el-drawer__body{height:100%;overflow-y:auto}\n", ""]);

// exports
